import dayjs from 'dayjs'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { httpService } from '@/service/http.service'
import type { Feed } from '@/types'

export const useNoticeStore = defineStore('notices', () => {
  const notices = ref<Feed[]>([])
  const lastUpdateTime = ref<dayjs.Dayjs | null>(null)

  async function fetchNotices() {
    try {
      notices.value = await httpService.infoboards.infoboardsPublicMessagesList(
        {
          type: 'notice'
        }
      )
      lastUpdateTime.value = dayjs()
    } catch {
      // console.log(err)
    }
  }
  return {
    fetchNotices,
    lastUpdateTime,
    notices
  }
})
